module.exports = __webpack_public_path__ + "img/project7.dbdd6dc3.png";